import * as React from 'react'
import SummaryPrice from '../../common/components/summary-price'
import QuoteNumber from '../../common/components/quote-number'
import StepTitle from '../../common/components/step-title'
import SubHeader from '../../common/components/sub-header'
import StepBlock from '../../common/components/step-block'
import Button from '../../common/components/button'
import Alert from '../../common/components/alert'
import { Table, Row, Cell } from '../../common/components/summary-table'
import { toCurrency, toCurrencyDecimal } from '../../common/util'
import { withConfig } from  '../../common/modules/config'
import { withValidation } from '../../common/modules/validation'
import { withForm } from '../../common/modules/form'
import { withSubmission } from '../../common/modules/submission'
import { withNavigation } from '../../common/modules/navigation'
import { withFields } from '../../common/modules/fields'
import { withProductData } from '../../common/modules/product-data'
import { withRouteBlocker } from '../../common/modules/route-blocker'
import { withScrollToTop } from '../../common/modules/scroll-to-top'
import { withState } from '../../common/modules/state'
import { get } from 'lodash'


export const formConfig = state => {
    const productData = state.productData;

    return {
        rules: {
            propertyExcess: [],
            waterDamageExcess: []
        },
        predicates:{},
        options:{},
        inferred:{
            voluntaryWorkersDeathSumsInsured: productData.productSumsInsured.VoluntaryWorkers[0].value,
            totalDisablement: Math.round(productData.productSumsInsured.VoluntaryWorkers[0].value * 0.01),
            fidelitySumsInsured: productData.productSumsInsured.Fidelity[0].value
        },
        transformOut: data => data,
    }
}


@withSubmission
@withNavigation
@withProductData
@withValidation
@withFields
@withRouteBlocker
@withScrollToTop
@withForm(formConfig)
export default class extends React.Component<any, any> {

    
    componentWillMount(){
        if(this.props.fields.declined || this.props.fields.referred){
            this.props.actions.navigation.setCloseWarning(false);
            this.props.actions.navigation.disableRoutes([
                "/step-1",
                "/step-2",
                "/step-3",
                "/step-4"
            ])
        }

        if(this.props.fields.declined){
            this.props.actions.navigation.changeRoute("/declined");
        }
    }


    render() {
        const fields = this.props.fields;
        const formData = this.props.form.getData();
        const inferred = formData.inferred;
        const productData = this.props.productData;
        
        return (
            <div className="row">
                <StepTitle>Quick Summary</StepTitle>
                <QuoteNumber />

                <SubHeader>Your Protection Overview</SubHeader>

                <Table>

                    <Row highlight>
                        <Cell><i className="fa fa-check-circle"></i> Insured Property</Cell><Cell></Cell>
                    </Row>

                    <Row>
                        <Cell>Building</Cell>
                        <Cell>${ toCurrency(fields.buildingSumInsured) }</Cell>
                    </Row>

                    <Row>
                        <Cell>Contents</Cell>
                        <Cell>${ toCurrency(fields.contentsSumInsured) }</Cell>
                    </Row>

                    <Row>
                        <Cell>Loss of Rent/Temporary Accommodation (total payable)</Cell>
                        <Cell>${ toCurrency(fields.lossOfRentSumInsured) }</Cell>
                    </Row>

                    <Row show={ fields.paintBenefit && fields.state == 'NSW' }>
                        <Cell>Optional Lot/Unit Wall Coverings</Cell>
                        <Cell>Selected</Cell>
                    </Row>

                    <Row>
                        <Cell>Property Excess</Cell>
                        <Cell>${ toCurrency(fields.propertyExcess) }</Cell>
                    </Row>

                    <Row>
                        <Cell help="This Excess will apply to Section 1 – Insured Property if the loss or damage is caused by Water Damage as defined in the PDS.">Water damage excess</Cell>
                        <Cell>${ toCurrency(fields.waterDamageExcess) }</Cell>
                    </Row>


                    <Row highlight>
                        <Cell><i className="fa fa-check-circle"></i> Liability to others</Cell><Cell></Cell>
                    </Row>

                    <Row>
                        <Cell>Sum insured</Cell>
                        <Cell>${ toCurrency(fields.liabilitySumInsured) }</Cell>
                    </Row>

                    <Row>
                        <Cell>Excess</Cell>
                        <Cell>${ toCurrency(fields.liabilityExcess) }</Cell>
                    </Row>


                    <Row highlight show={ fields.voluntaryWorkersInsured == true || fields.voluntaryWorkersRequired == true }>
                        <Cell><i className="fa fa-check-circle"></i> Voluntary Workers</Cell><Cell></Cell>
                    </Row>

                    <Row show={ fields.voluntaryWorkersInsured == true || fields.voluntaryWorkersRequired == true }>
                        <Cell>Death</Cell>
                        <Cell>${ toCurrency(inferred.voluntaryWorkersDeathSumsInsured) }</Cell>
                    </Row>

                    <Row show={ fields.voluntaryWorkersInsured == true || fields.voluntaryWorkersRequired == true }>
                        <Cell>Total Disablement</Cell>
                        <Cell>${ toCurrency(inferred.totalDisablement) }</Cell>
                    </Row>

                    <Row highlight show={ fields.fidelityGuaranteeInsured == true }>
                        <Cell><i className="fa fa-check-circle"></i> Fidelity Guarantee</Cell>
                        <Cell>${ toCurrency(inferred.fidelitySumsInsured) }</Cell>
                    </Row>

                </Table>

                <StepBlock className="mt-4">
                    <Alert show={ fields.floodCover == "REQUIRED" } ><p>Flood cover is included with the policy</p></Alert>
                    <Alert show={ fields.floodCover == "NOT_INCLUDED" } ><p>This policy does not included flood cover</p></Alert>
                </StepBlock>


                <SubHeader>Additional Optional Covers that may be available</SubHeader>

                <Table>
                    <Row show={ !fields.voluntaryWorkersInsured || fields.voluntaryWorkersRequired != true }>
                        <Cell>Voluntary Workers</Cell>
                        <Cell className="text-center">Not Insured</Cell>
                    </Row>
                    
                    <Row show={ fields.workersCompensationInsured }>
                        <Cell>Workers Compensation</Cell>
                        <Cell className="text-center" show={ fields.workersCompensationInsured == true}><i className="fa fa-check-circle"></i></Cell>
                        <Cell className="text-center" show={ fields.workersCompensationInsured != true} >Not Insured</Cell>
                    </Row>

                    <Row show={ fields.fidelityGuaranteeInsured != true } >
                        <Cell>Fidelity Guarantee</Cell>
                        <Cell className="text-center">Not Insured</Cell>
                    </Row>

                    <Row show={ fields.paintBenefit != true && fields.state == 'NSW' } >
                        <Cell>Optional Lot/Unit Wall Coverings</Cell>
                        <Cell className="text-center">Not Insured</Cell>
                    </Row>

                    <Row>
                        <Cell>Office Bearers Legal Liability</Cell>
                        <Cell className="text-center" show={ fields.officeBearersInsured == true }><i className="fa fa-check-circle"></i></Cell>
                        <Cell className="text-center" show={ fields.officeBearersInsured != true } >Not Insured</Cell>
                    </Row>

                    <Row>
                        <Cell>Machinery Breakdown</Cell>
                        <Cell className="text-center" show={ fields.machineryBreakdownInsured == true }><i className="fa fa-check-circle"></i></Cell>
                        <Cell className="text-center" show={ fields.machineryBreakdownInsured != true }>Not Insured</Cell>
                    </Row>

                    <Row>
                        <Cell>Cost of Removal, Storage and Evacuation</Cell>
                        <Cell className="text-center" show={ fields.catastropheInsured == true }><i className="fa fa-check-circle"></i></Cell>
                        <Cell className="text-center" show={ fields.catastropheInsured != true }>Not Insured</Cell>
                    </Row>

                    <Row>
                        <Cell>Government Audit Costs and Legal Expenses</Cell>
                        <Cell className="text-center">Not Insured</Cell>
                    </Row>

                    <Row>
                        <Cell>Lot Owner's Fixtures and Improvements</Cell>
                        <Cell className="text-center">Not Insured</Cell>
                    </Row>

                </Table>

                <div className="col-12">
                    <div className="summary-price-info white-text">
                        { (!fields.referred && fields.basePremium) &&
                            <div className="summary-price-top d-sm-flex justify-content-start">
                                <h2 className="mr-auto"><strong className="white-text">It could be as low&nbsp;as </strong></h2>
                                <div className="text-sm-right">
                                    <div><h2 className="d-inline"><strong>${ toCurrencyDecimal(fields.totalPayable) }</strong></h2></div>
                                </div>
                            </div>
                        }
                         <div className="summary-price-bottom d-flex align-items-start">
                            { (!fields.referred && !fields.declined && fields.basePremium) &&
                                <p>This price is indicative based on an assessment of an average Strata Plan
                                and the information you have already provided. We will require your
                                building details and extra covers to confirm a purchase price.</p>
                            }
                            { !(!fields.referred && !fields.declined && fields.basePremium) &&
                                <p>We still require your building details and extra covers in order to provide you with a price.
                                Please continue to the next step.</p>
                            }
                        </div>
                    </div>
                </div>


                
                <Button.Container>
                    <Button.Back route="/step-3" /> <Button.Save onClick={ this.save.bind(this) }/> <Button.Continue onClick={ this.onContinue.bind(this)} />
                </Button.Container>

            </div>
        )
    }


    save(){
        this.props.actions.submission.save("/step-4", [
            require("./step-1").formConfig,
            require("./step-2").formConfig,
            require("./step-3").formConfig,
            require("./step-4").formConfig,
        ]);
    }


    onContinue(){
        this.props.actions.navigation.changeRoute("/step-5");
    }

}




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/isaver-quote/routes/step-4.tsx